export default {
  upload_common: {
    required: '此项为必填项。',
    max_length_500: '字数须在500字以内。',
    please_enter_a_number: '请输入数字。',
    unexpected_error: '发生了意外错误。',
    temporarily_saved: '已临时保存。',
    unanswered_items: '存在未回答的项目。',
    answer_questionnaire_select: '请选择要回答的调查表。',
    entry: '请填写',
    target_select: '请选择。',
    value_unit: '值',
    unit: '单位',
    attach_documents: '添加文件',
    textarea_placeholder: '请在此处按要求填写说明或者添加补充信息。',
    // textarea_placeholder_with_file: '',
    temporary_storage: '临时保存',
    submit: '提交',
    last_saved_temporary: '最终草稿保存日期',
    There_are_unanswered_questions: '存在未回答的项目',
    submitted_text: '此问卷/调查已提交。',
    submitted_at: '提交日期',
    withdrawal_of_answer: '撤回回答',
    withdrawal_accepted: '回答已退回',
    help: '帮助',
    example_of_evidence: '凭证示例',
    save_temporary_answer: '临时保存问卷/调查',
    saved_temporary_answer: '回答内容已临时保存。',
    submit_answer: '提交问卷/调查',
    confirm_submit_answer: '确定要提交您当前正在完成的问卷/调查吗？',
    confirm_submit_shared_text: '\n回答内容将与请求调查的企业共享。',
    complete_submit_answer: '问卷/调查已提交。\n谢谢您的协助。',
    // recommend_asuene: '',
    // not_at_all: '',
    // absolutely: '',
    // let_us_know_your_thoughts: '',
    // thank_you_for_your_cooperation: '',
    // glad_to_support: '',
    back_answer: '返回回答',
    close: '关闭',
    save_temporary_answer_and_prev: '保存并返回',
    save_temporary_answer_and_next: '保存并继续',
    prev: '返回',
    next: '继续',
    question_group_question_download: '问题下载',
    question_group_answer_download: '下载回答',
    question_group_download_answer_csv_title: '问题・回答(CSV)',
    question_group_download_answer_csv_description: '答案将以CSV格式下载',
    question_group_download_answer_pdf_title: '问题・回答(PDF)',
    question_group_download_answer_pdf_description: '答案将以PDF格式下载',
    question_group_download_scorecard_pdf_title: '得分卡(PDF)',
    question_group_download_scorecard_pdf_description: '得分将以PDF格式下载',
    question_group_download_esg_award_svg_title: 'ESG奖项(SVG)',
    question_group_download_esg_award_svg_description: '奖项将以SVG格式下载',
    question_group_download_esg_award_pdf_title: 'ESG奖项(PDF)',
    question_group_download_esg_award_pdf_description: '奖项将以PDF格式下载',
    request_survey_withdrawal: '请求撤回回答',
    survey_withdrawal_description: '要求委托评估公司撤回回答。\n请在下面写下您希望撤回的原因并发送。内容将显示给委托评估公司。',
    reason_withdrawal_request: '希望撤回的原因',
    completed_withdrawal_request: '已请求撤回答复。\n在驳回之前，请稍候。',
    send: '发送',
    cancel: '取消',
    balloon_title_withdrawal_request: '已请求撤回答复。',
    no_survey: '无调查/问卷的答复请求。',
    failed_to_save_before_export: '下载之前的临时保存失败。请检查输入内容是否有误。',
    filter_unfilled_questions: '仅显示未回答的问题',
    no_unfilled_questions: '没有未回答的问题。',
    move_page: '移动页面',
    confirm_move_page_message: '回答内容未保存。\n如果继续移动，数据将会丢失。您想保存然后移动吗？',
    confirm_without_save: '移动而不保存',
    confirm_with_save: '保存后移动',
    error_save: '无法临时保存请确认输入内容',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: '编辑中的问卷/调查',
    unable_edit_someone_editing_survey: '该问卷/调查当前无法编辑，因为有用户正在回答',
    user_editing_survey: '正在编辑',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: '历史回答内容',
      // overwrite_with_previous_answers: "",
      submitted_at: '（{submitted_at} 提交）',
      // related_question: "",
      click_to_expand: '点击展开',
      click_to_omit: '点击跳过',
      // description: "",
      answer_reference_function: '回答传递功能',
      overwrite: '覆盖',
      overwrite_confirm: '在回答中的问卷/调查中自动输入历史回答。\n已输入的答案将会被覆盖。',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: '项目',
      activity_amount: '有效质量',
      emission_factor: '排放系数',
      emission_amount: '排放量',
      unit_sale: '销售额强度',
      total: '合计',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/百万日元',
    },
    label: {
      required_answer: '必答',
      optional_answer: '选答',
      conditional_required_answer: '按条件必答',
      note: '备注',
      // evidence_attachments: "",
    },

    //  required_answer: '',
    //  optional_answer: '',
    //  conditional_required_answer: '',
    //  note: '',
    //  evidence_attachments: '',

    // no_available_in_pdf: ''
    // comparison_question_meta: '',
    // error_footer: '',
    // error_panel_title: '',
    // error_panel_description: '',
    // error_panel_support_text_1: '',
    // error_panel_support_label: '',
    // error_panel_support_text_2: '',
    // error_panel_resolved: '',
    // error: '',
    // error_revision_required: '',
    // alert: '',
    // alert_detected: '',
    question_group_download_answered_csv_title: '问题・回答(CSV)',
    question_group_download_answered_pdf_title: '问题・回答(PDF)',
  }
}
